import styled from '@emotion/styled'

const SectionIntro = styled.div`
  margin: 7rem 0;
`

export default SectionIntro



// WEBPACK FOOTER //
// ./src/routes/home/components/SectionIntro.js